<section class="nxnback flex" id="picker">
  <article class="content-wrap txt-center full-width">
    <h2 class="uppercase margin-bottom-40 normal-3">
      {{ 'PICKER.title' | translate }}
    </h2>
    <h3 class="margin-bottom-30">{{ 'PICKER.brief' | translate }}</h3>

    <ng-container *ngIf="!pickerForm.valid || !enableLogin">
      <p class="margin-bottom-20" style="color: #a94442; font-size: 0.8rem;">
        <ng-container *ngIf="('lang' | translate) === 'en'">
          You have invalid picks. Check the numbers chosen.
        </ng-container>
        <ng-container *ngIf="('lang' | translate) === 'es'">
          Tienes picks invalidos. Revisa tus numeros elegidos!
        </ng-container>
        <ng-container *ngIf="('lang' | translate) === 'pt'">
          Você tem escolhas inválidas. Verifique os números escolhidos.
        </ng-container>
      </p>
    </ng-container>

    <form [formGroup]="pickerForm">
      <div formArrayName="basePick">
        <div *ngFor="let pickers of basePick.controls; let picker = index" class="picker-container font flex x-content-center margin-bottom-20">
          <a href="#picker" role="buttom" class="buttom quickpick" (click)="quickPick(picker)">
            <i class="relative inline-block arrow-circle"></i> Quick Pick
          </a>
          <div *ngFor="let b of pickers.controls; let i = index" class="picks">
            <input
              *ngIf="i < picksCount"
              type="number"
              class="basePicks"
              required
              [formControl]="b"
              min="{{ picksFrom }}"
              max="{{ picksTo }}"
              (ngModelChange)="userInputControl(picker, i)"
            />
            <input
              *ngIf="i >= picksCount"
              type="number"
              class="extraPicks"
              required
              min="{{ extraPicksFrom }}"
              max="{{ extraPicksTo }}"
              [formControl]="b"
              (ngModelChange)="userInputControl(picker, i)"
            />
          </div>
          <span *ngIf="picker < base" class="price-amount">
            <small>
              <ng-container *ngIf="currency == 'USD'">US</ng-container>
              <ng-container *ngIf="currency == 'BRL'">R</ng-container>
              <ng-container *ngIf="currency == 'AUD'">$</ng-container>
              <ng-container *ngIf="currency == 'PLN'">Z</ng-container>
            </small>
            <ng-container *ngIf="currency == 'USD' || currency == 'CAD' || currency == 'BRL'">$</ng-container>
            <ng-container *ngIf="currency == 'EUR'">&euro;</ng-container>
            <ng-container *ngIf="currency == 'GBP'">&pound;</ng-container>
            <ng-container *ngIf="currency == 'AUD'">A</ng-container>
            <ng-container *ngIf="currency == 'PLN'">ł</ng-container>
            {{ ticketPrice }}
          </span>
          <span *ngIf="picker >= base" class="price-free">{{ 'PICKER.free' | translate | uppercase }}</span>
        </div>
      </div>
    </form>

    <div class="play flex wrap margin-top-50">
      <div class="logo">
        <app-logo-lotto></app-logo-lotto>
      </div>
      <div class="countdown">
        <p>{{ multiplier }} {{ 'LottoPlays' | translate }}</p>
        <figure class="relative-left full-height">
          <app-countdown></app-countdown>
        </figure>
      </div>
      <div class="play-buttom">
        <p class="price uppercase">
          Total:
          <small>
            <ng-container *ngIf="currency == 'USD'">US</ng-container>
            <ng-container *ngIf="currency == 'BRL'">R</ng-container>
            <ng-container *ngIf="currency == 'AUD'">$</ng-container>
            <ng-container *ngIf="currency == 'PLN'">Z</ng-container>
          </small>
          <ng-container *ngIf="currency == 'USD' || currency == 'CAD' || currency == 'BRL'">$</ng-container>
          <ng-container *ngIf="currency == 'EUR'">&euro;</ng-container>
          <ng-container *ngIf="currency == 'GBP'">&pound;</ng-container>
          <ng-container *ngIf="currency == 'AUD'">A</ng-container>
          <ng-container *ngIf="currency == 'PLN'">ł</ng-container>
          {{ totalTicketPrice }}
        </p>
        <button
          mat-button
          [ngClass]="{ disabled: !enableLogin || basePick.status == 'INVALID' }"
          class="play-now md full-width"
          (click)="showLogin($event)"
        >
          {{ 'PlayNow' | translate }}
        </button>
      </div>
    </div>
  </article>
  <div class="intro-form grow-2 login">
    <app-login *ngIf="upLogIn"></app-login>
  </div>
  <div *ngIf="upLogIn" class="block-shadow" (click)="hideLogin()"></div>
</section>
